import AppState from "store/AppState";

export const selectLinkedCategories = (state: AppState) =>
  state.linkedCategories.data;

export const selectLinkedCategoriesLoading = (state: AppState) =>
  state.linkedCategories.loading;

export const selectLinkedCategoriesUploadProgress = (state: AppState) =>
  state.linkedCategories.uploadProgress;

export const selectLinkedCategoriesUploadSuccess = (state: AppState) =>
  state.linkedCategories.isUploadSuccess;

export const selectLinkedCategorySetByCategory = (
  state: AppState,
  storeId: string | null,
  catalogId: string,
  categoryId: string,
) =>
  state.linkedCategories.linkedCategorySetByCategory.categories.filter(
    (category) =>
      !(
        category.storeId === storeId &&
        category.catalogId === catalogId &&
        category.categoryId === categoryId
      ),
  );
